/**
 * Build a pdfmake table node from headers/rows with a bordered layout.
 * Adds subtle grid lines and compact padding; respects project radius cap via visuals only (no rounded borders).
 *
 * @param {Object} p
 * @param {string[]} [p.headers]
 * @param {Array<Array<string|number|object>>} [p.rows]
 * @param {Array<string|number|'auto'|'*'>} [p.widths]
 * @returns {{layout:object, table:{headerRows:number, body:any[][], widths?:any[]}}}
 */
export function buildGridFromRows({ headers = null, rows = [], widths = null }) {
  try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][block][grid] build', { headers: headers?.length || 0, rows: rows?.length || 0, widths: Array.isArray(widths) ? widths.length : widths }); } catch(_){}

  const body = [];
  if (headers && headers.length) {
    body.push(headers.map(h => ({ text: String(h), style: 'th' })));
  }
  for (const r of rows) {
    body.push((Array.isArray(r) ? r : []).map(c => (c && typeof c === 'object') ? c : { text: String(c ?? '') }));
  }

  // Ensure widths is either an array or undefined (pdfmake expects array for tables)
  const tableWidths = Array.isArray(widths)
    ? widths
    : (headers && headers.length ? headers.map(() => 'auto') : undefined);

  const node = {
    layout: {
      hLineWidth: () => 0.5,
      vLineWidth: () => 0.5,
      hLineColor: '#E5E7EB',
      vLineColor: '#E5E7EB',
      paddingLeft: () => 6,
      paddingRight: () => 6,
      paddingTop: () => 6,
      paddingBottom: () => 6,
    },
    table: {
      headerRows: headers && headers.length ? 1 : 0,
      body,
    }
  };
  if (tableWidths) node.table.widths = tableWidths;
  try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][block][grid] ready', { headerRows: node.table.headerRows, columns: Array.isArray(node.table.widths) ? node.table.widths.length : node.table.widths, bodyRows: node.table.body.length }); } catch(_){}
  return node;
}
